import {    
    AppContextIdName,
    ReturnCenterDisplaySettingsResponse,
    ReturnCenterSettings,
} from 'returnCenter-api';
import { configurationApi } from './api';
import { getLanguage } from './languageStore';

/**
 * Configuration service - handles configuration-related API calls
 * Maps to ConfigurationController endpoints
 */
export const configService = {
    /**
     * Get available companies for the current user
     */
    getCompanies: async (): Promise<Array<AppContextIdName>> => {
        const response = await configurationApi.configurationGetCompanies();
        return response.data;
    },

    /**
     * Get app display settings (theme, colors, etc.)
     */
    getAppDisplaySettings: async (): Promise<ReturnCenterDisplaySettingsResponse> => {
        const response = await configurationApi.configurationGetAppDisplaySettings();
        return response.data;
    },

    /**
     * Get return center settings
     */
    getReturnCenterSettings: async (): Promise<ReturnCenterSettings> => {
        const response = await configurationApi.configurationGetReturnCenterSettings({ language: getLanguage() });
        return response.data;
    },
};
